export default "__VITE_ASSET__DVGpj6na__"